import React, { useEffect, useRef, useState } from 'react';

import { ChevronLeft, ChevronRight } from '@hpstellar/icons';
import { ArrowRight, ArrowLeft } from '@hpstellar/vis-icons';

import withWindowResize from '../../../ui/components/window-resize';

import './scroll-container.less';

const SCROLL_DISTANCE = 144;

function ScrollContainer({ children, className, width, visId }) {
    const [overflow, setOverflow] = useState(width < 1572);
    const [left, setLeft] = useState(false);

    const scrollElement = useRef(null);

    const handleScroll = () => {
        const { scrollLeft, scrollWidth, offsetWidth } = scrollElement.current;

        setLeft(scrollLeft > 0);

        if (scrollLeft + offsetWidth >= scrollWidth) {
            setOverflow(false);
        } else {
            setOverflow(offsetWidth < scrollWidth);
        }
    };

    useEffect(() => {
        // TODO: find a way to add listener to size changes, currently not getting
        // the correct width on initial render so arrows not being set correctly
        setTimeout(() => {
            handleScroll();
        }, 1500);
    }, []);

    useEffect(() => {
        const { clientWidth, scrollWidth, offsetWidth } = scrollElement.current;

        if (offsetWidth < scrollWidth) {
            setOverflow(true);
        } else {
            setOverflow(false);
        }

        if (clientWidth === scrollWidth) {
            setLeft(false);
        }
    }, [scrollElement, width]);

    useEffect(() => {
        scrollElement.current.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            scrollElement?.current?.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const onClickScroll = (direction = true) => {
        scrollElement.current.scrollLeft += direction ? SCROLL_DISTANCE : -SCROLL_DISTANCE;
    };

    return (
        <>
            {left && (
                <div className="scrollButton left">
                    <button
                        type="button"
                        aria-label="Scroll Left"
                        className="slideButton"
                        onClick={() => onClickScroll(false)}
                    >
                        {visId ? <ArrowLeft size="s" /> : <ChevronLeft />}
                    </button>
                </div>
            )}
            <div className={`scrollContainer ${className}`} ref={scrollElement}>
                {children}
            </div>
            {overflow && (
                <div className="scrollButton right">
                    <button type="button" aria-label="Scroll Right" className="slideButton" onClick={onClickScroll}>
                        {visId ? <ArrowRight size="s" /> : <ChevronRight />}
                    </button>
                </div>
            )}
        </>
    );
}

export default withWindowResize(ScrollContainer);
